import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import './TooltippedElement.less';

export default function TooltippedElement(props) {
  let { tooltip, newLineIcon, styledHelpIcon, widePopover } = props;
  styledHelpIcon = styledHelpIcon ?? {};

  const renderTooltip = (props) => (
    <Popover id="facts-popover" className={widePopover ? 'wide-popover' : ''} {...props}>
      <Popover.Body style={widePopover ? stylePopoverBody2 : stylePopoverBody}>
        {tooltip}
        {' '}
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      {props.children}
      &nbsp;
      {newLineIcon && <br />}
      <OverlayTrigger
        placement="top"
        overlay={renderTooltip}
      >
        <HelpOutlineIcon style={props?.iconSize ? { ...styledHelpIcon, ...{ opacity: '0.66', fontSize: props.iconSize } } : { ...styledHelpIcon, ...{ opacity: '0.66' } }} fontSize="inherit" />
      </OverlayTrigger>
    </>
  );
}

const stylePopoverBody = {
  whiteSpace: 'pre-wrap',
  fontSize: '13px',
  lineHeight: '18px',
  textAlign: 'center',
  padding: '28px 20px',
  color: '#72808E',
};

const stylePopoverBody2 = {
  whiteSpace: 'pre-wrap',
  fontSize: '13px',
  lineHeight: '18px',
  textAlign: 'center',
  padding: '28px 20px',
  color: '#72808E',
  width: '700px'
};
